<!-- <span style="display: none;"> {{ item | json }} {{  !!isOpen | json }} {{  !!isActive | json }} {{ isLink(item) | json }} {{ isRemoteUrl(item) | json }} </span> -->

<a *ngIf="isLink(item) && !isFunction(item.route)"
   [fragment]="item.fragment"
   [routerLinkActiveOptions]="item.routerLinkActive || { exact: true }"
   [routerLink]="item.route"
   class="item"
   [class.active]="isOpen || isActive"
   fxLayout="row"
   matRipple
   routerLinkActive="active">
  <mat-icon *ngIf="level === 0" [icIcon]="item.icon" class="item-icon" fxFlex="none"></mat-icon>
  <span class="item-label" fxFlex="auto">{{ item.label | translate }}</span>
  <span *ngIf="item.badge"
        [style.background]="item.badge.background"
        [style.color]="item.badge.color"
        class="item-badge"
        fxFlex="none">{{ item.badge.value }}</span>
</a>

<a *ngIf="isRemoteUrl(item)"
   href="{{item.remoteUrl}}"
   class="item"
   fxLayout="row"
   target="_blank"
   matRipple
   routerLinkActive="active">
  <mat-icon *ngIf="level === 0" [icIcon]="item.icon" class="item-icon" fxFlex="none"></mat-icon>
  <span class="item-label" fxFlex="auto">{{ item.label | translate }}</span>
  <span *ngIf="item.badge"
        [style.background]="item.badge.background"
        [style.color]="item.badge.color"
        class="item-badge"
        fxFlex="none">{{ item.badge.value }}</span>
</a>

<div (click)="item.route()"
     *ngIf="isLink(item) && isFunction(item.route)"
     [class.active]="isOpen || isActive"
     class="item"
     fxLayout="row"
     matRipple
     routerLinkActive="active">
  <mat-icon *ngIf="level === 0" [icIcon]="item.icon" class="item-icon" fxFlex="none"></mat-icon>
  <span class="item-label" fxFlex="auto">{{ item.label | translate }}</span>
  <span *ngIf="item.badge"
        [style.background]="item.badge.background"
        [style.color]="item.badge.color"
        class="item-badge"
        fxFlex="none">{{ item.badge.value }}</span>
</div>

<ng-container *ngIf="isDropdown(item)">
  <div (click)="toggleOpen()"
       [class.active]="isOpen || isActive"
       [class.open]="isOpen"
       class="item"
       fxLayout="row"
       matRipple>
    <mat-icon *ngIf="level === 0" [icIcon]="item.icon" class="item-icon" fxFlex="none"></mat-icon>
    <span class="item-label" fxFlex="auto">{{ item.label | translate }}</span>
    <span *ngIf="item.badge"
          [style.background]="item.badge.background"
          [style.color]="item.badge.color"
          class="item-badge"
          fxFlex="none">{{ item.badge.value }}</span>
    <mat-icon [icIcon]="icKeyboardArrowRight" class="item-dropdown-icon" fxFlex="none"></mat-icon>
  </div>
  <div [@dropdown]="isOpen" class="item-dropdown">
    <vex-sidenav-item *ngFor="let subItem of item.children" [item]="subItem" [level]="level + 1"></vex-sidenav-item>
  </div>
</ng-container>


<ng-container *ngIf="isSubheading(item)">
  <div class="subheading">{{ item.label | translate }}</div>
  <vex-sidenav-item *ngFor="let subItem of item.children" [item]="subItem" [level]="0"></vex-sidenav-item>
</ng-container>

